module.exports = __webpack_public_path__ + "assets/img/mobtmn-banner.c5705423.png";